import dayjs from 'dayjs';

const convertToDayjs = (date: Date | string, format: ?string) =>
  format ? dayjs(date, format) : dayjs(date);

export default convertToDayjs;
